module.exports = __webpack_public_path__ + "angular-locale_en.js";